import AbstractAsset from '@/editor/assets/abstract.asset'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'
// import { DEFAULT_DURATION } from '@/etc/consts'

export default class D3Asset extends AbstractAsset {
  constructor(uuid) {
    super(uuid)
    this._type = 'd3'
    this._props = {
      ...this._props,
      'position.x': 0,
      'position.y': 0,
      'position.z': 0,
      'scale.x': 1,
      'scale.y': 1,
      'scale.z': 1,
      'rotation.x': 0,
      'rotation.y': 0,
      'rotation.z': 0,
      opacity: 1,
    }
  }

  get D() {
    return 3
  }

  get resizable() { return true }

  get PROPS() {
    return {
      position: {
        // machine-readable
        type: 'object',
        name: 'Position', // human readable
        tool: 'Translate3D',
        fields: {
          x: { type: 'number', name: 'X' },
          y: { type: 'number', name: 'Y' },
          z: { type: 'number', name: 'Z' },
        },
      },
      scale: {
        type: 'object',
        name: 'Scale',
        tool: 'Scale3D',
        fields: {
          x: { type: 'number', name: 'X' },
          y: { type: 'number', name: 'Y' },
          z: { type: 'number', name: 'Z' },
        },
      },
      rotation: {
        type: 'object',
        name: 'Rotation',
        tool: 'Rotate3D',
        fields: {
          x: { type: 'number', name: 'X' },
          y: { type: 'number', name: 'Y' },
          z: { type: 'number', name: 'Z' },
        },
      },
      opacity: {
        type: 'number',
        name: 'Opacity',
        normalized: true,
        tool: 'OpacitySlider',
      },
    }
  }

  loadFromFile(file) {
    return new Promise(resolve => {
      const loader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('/vendor/draco/')
      loader.setDRACOLoader(dracoLoader)
      loader.load(
        URL.createObjectURL(file),
        (gltf) => {
          this._asset.meta.name = file.name
          this._asset.gltf = gltf
          this._asset.ready = true
          this.emit('ready')
          resolve()
        },
        (progress) => {
          this.dbg.info('progress load', progress)
        },
        (err) => {
          this.dbg.error('load error', err)
          resolve()
        }
      )
    })
  }
  /*
  async loadFromFile(file) {
    await super.loadFromFile(file)
    this._asset.meta.name = file.name
    await this.loadInfo()
    this._asset.ready = true
    this.emit('ready')
  }
  */

  initAnimationD2(settings, zeroFrame) {
    const animation = super.initAnimation(settings)
    this.dbg.log('zf', zeroFrame, this._asset.meta)
    let scale = 1
    if (
      !zeroFrame ||
      (this._asset.meta.height < zeroFrame.height &&
        this._asset.meta.height < zeroFrame.height)
    ) {
      scale = 1
    } else {
      // not fits to screen, scale down
      scale = Math.min(
        zeroFrame.width / this._asset.meta.width,
        zeroFrame.height / this._asset.meta.height
      )
    }
    // Apply fit-to-screen scale and opacity to defaults so V2 (no keys) renders correctly
    this._props['scale.x'] = scale
    this._props['scale.y'] = scale
    this._props.opacity = 1
    if (animation.keyframes[0]) {
      animation.keyframes[0].props['scale.x'] = scale
      animation.keyframes[0].props['scale.y'] = scale
      animation.keyframes[0].easing['scale.x'] = 'Linear.None'
      animation.keyframes[0].easing['scale.y'] = 'Linear.None'
      animation.keyframes[0].delay['scale.x'] = 0
      animation.keyframes[0].delay['scale.y'] = 0
      animation.keyframes[0].props.opacity = 1
      animation.keyframes[0].easing.opacity = 'Linear.None'
      animation.keyframes[0].delay.opacity = 0
    }

    if (animation.keyframes[1]) animation.keyframes[1].props.opacity = 1
    return animation
  }



  initAnimation(settings, zeroFrame) {
    const animation = super.initAnimation(settings)
    this.dbg.log('zf', zeroFrame, this._asset.meta)
    if (
      !zeroFrame ||
      (this._asset.meta.height < zeroFrame.height &&
        this._asset.meta.height < zeroFrame.height)
    )
      return animation
    // not fits to screen, scale down
    // const length = this.meta.duration || DEFAULT_DURATION
    // this.dbg.info('animation', animation)
    // Ensure defaults when no keys
    this._props.opacity = 1
    if (animation.keyframes[0]) {
      animation.keyframes[0].props.opacity = 1
      animation.keyframes[0].easing.opacity = 'Linear.None'
      animation.keyframes[0].delay.opacity = 0
    }

    // animation.keyframes[1].props.opacity = 1
    // animation.keyframes[1].easing.opacity = 1
    // animation.keyframes[1].delay.opacity = length

    if (animation.keyframes[1]) animation.keyframes[1].props.opacity = 1
    return animation
  }

  updateFrame(time, localTime, frame, zf, isPlay, propsUp) {
    this.dbg.log('updateFrame', time, localTime, frame)
    // const props = super.updateFrame(time, localTime, frame)
    const props = typeof propsUp === 'undefined'
      ? super.updateFrame(time, localTime, frame)
      : propsUp
    if (!frame || !frame.animation || !frame.mesh || !frame.strip) return props
    if (localTime < 0 || localTime > frame.strip.length) {
      frame.mesh.visible = false
      frame.mesh.layers.set(2)
      return props
    }
    frame.mesh.visible = true
    frame.mesh.layers.set(1)
    this.dbg.log('updateFrame', { time, localTime, frame, props })
    frame.mesh.position.set(props['position.x'], props['position.y'], props['position.z'])
    frame.mesh.scale.set(props['scale.x'], props['scale.y'], props['scale.z'])
    frame.mesh.rotation.x = props['rotation.x']
    frame.mesh.rotation.y = props['rotation.y']
    frame.mesh.rotation.z = props['rotation.z']
    if (frame.mesh.material)
      frame.mesh.material.opacity = props.opacity
    return props
  }

  toolUpdate(update) {
    const ret = super.toolUpdate(update)
    if (update.tool === 'Translate2D') {
      ret['position.x'] = update.position.x
      ret['position.y'] = update.position.y
      // ret['position.z'] = update.position.z
    }
    if (update.tool === 'Translate3D') {
      ret['position.x'] = update.position.x
      ret['position.y'] = update.position.y
      ret['position.z'] = update.position.z
    }
    if (update.tool === 'Scale2D') {
      ret['scale.x'] = update.scale.x
      ret['scale.y'] = update.scale.y
      // ret['scale.z'] = update.scale.z
    }
    if (update.tool === 'Scale3D') {
      ret['scale.x'] = update.scale.x
      ret['scale.y'] = update.scale.y
      ret['scale.z'] = update.scale.z
    }
    if (update.tool === 'Rotate2D') {
      this.dbg.info('rotation update', update)
      // ret['rotation.x'] = update.rotation.x
      // ret['rotation.y'] = update.rotation.y
      ret['rotation.z'] = update.rotation.z
    }
    if (update.tool === 'Rotate3D') {
      this.dbg.info('rotation update', update)
      ret['rotation.x'] = update.rotation.x
      ret['rotation.y'] = update.rotation.y
      ret['rotation.z'] = update.rotation.z
    }
    if (update.tool === 'OpacitySlider') {
      ret.opacity = update.opacity
    }
    return ret
  }
}
